const DadataCountry = () => {
  const countryInput = document.getElementById('country');
  const countriesList = document.querySelector('.countries-list');

  if (countryInput) {
    countryInput.addEventListener('input', () => {
      
      const countries = [
        {value: 'Estonia'},
        {value: 'Latvia'},
        {value: 'Lithuania'},
      ];
      console.log(countries);
      displayCountries(countries);
    });
  }

  const displayCountries = (countries) => {
    countriesList.innerHTML = '';

    if (countries.length > 0) {
      countriesList.classList.add("opened");
      countryInput.classList.remove('invalid-search');

      countries.forEach(country => {
        const countryItem = document.createElement('div');
        countryItem.classList.add('countries-item');
        countryItem.textContent = country.value;

        countryItem.addEventListener('click', () => {
          countryInput.value = country.value;
          countriesList.classList.remove("opened");
        });

        countriesList.appendChild(countryItem);
      });
    } else {
      countriesList.classList.remove("opened");
      countryInput.classList.add('invalid-search');
    }
  };
};

export default DadataCountry;

